import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { useForm } from "react-hook-form";
import { DialogTitle, FormButton } from "suregifts-component-lib";
import { toast } from "react-toastify";
import AddEditStoreView from "./AddEditStoreView";
import { yupResolver } from "@hookform/resolvers/yup";
import { storeSchema } from "./schema";
import { CreateEditStoreModel, StoreData } from "../../../../shared/merchants";
import { useEditStore } from "../../../../services/merchant-dashboard/merchant";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useQueryClient } from "react-query";

function EditStoreModal() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("..");
  };
  const { mutate: editStore, isLoading } = useEditStore();
  const [store] = useState(() => {
    const data = sessionStorage.getItem("STORE_DATA");
    if (!data) return {} as StoreData;
    return JSON.parse(data) as StoreData;
  });

  const submitForm = (data) => {
    editStore(data, {
      onSuccess: () => {
        toast.success("Store created successfully.");
        queryClient.invalidateQueries("stores");
        handleClose();
      },
    });
  };
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<CreateEditStoreModel>({
    defaultValues: {
      ...store!,
      stateId: store?.stateId ?? "",
    },
    resolver: yupResolver(storeSchema),
  });
  return (
    <Dialog open maxWidth={"xs"} scroll="paper">
      <DialogTitle title="Edit Store" handleClose={handleClose} />
      <DialogContent>
        <AddEditStoreView control={control} errors={errors} register={register} />
      </DialogContent>
      <DialogActions>
        <FormButton label="Edit" loading={isLoading} fullWidth onClick={handleSubmit(submitForm)} />
      </DialogActions>
    </Dialog>
  );
}
export default EditStoreModal;
